<template>
<div>

    <el-crud :baseUrl="'/holidays'" 
        v-model="resource"
        :actions="['edit','delete']"
        :config="crudConfig"
        ref="crud">

        <template slot="table">
            <el-table-column
                prop="date"
                label="Fecha">
            </el-table-column>
            <el-table-column
                prop="description"
                label="Descripción">
            </el-table-column>
        </template>

        <template slot="form" slot-scope="scope">
            <el-form-item label="Fecha" label-width="120px" prop="date" :error="scope.errors.date">
                <el-date-picker v-model="resource.date" 
                format="yyyy-MM-dd" :picker-options="{firstDayOfWeek:1}" placeholder="Fecha"></el-date-picker>
            </el-form-item>
            <el-form-item label="Descripción" label-width="120px" prop="description" :error="scope.errors.description">
                <el-input v-model="resource.description" auto-complete="off"></el-input>
            </el-form-item>
        </template>
    </el-crud>

</div>
</template>

<script>
    import el_crud from '../el-crud.vue';
    export default {
        data() {
            return {
                crudConfig:{
                    AddItemTitle: 'Nuevo Día Festivo',
                    EditItemTitle: 'Editar Día Festivo',
                    DeleteItemConfirmMessage: 'Esto borrará permanentemente el día festivo. Desea continuar?'
                },
                resource:{
                    date: null,
                    description: null,
                },
            }
        },
        components: {
            'el-crud': el_crud,
        },
        methods: {
        }
    }
</script>
